import { render, staticRenderFns } from "./AssignmentDetail.vue?vue&type=template&id=67683ed8&scoped=true"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js"
import style0 from "./AssignmentDetail.vue?vue&type=style&index=0&id=67683ed8&prod&scoped=true&lang=css"
import style1 from "./AssignmentDetail.vue?vue&type=style&index=1&id=67683ed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67683ed8",
  null
  
)

export default component.exports